import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { PERCENTAGE_PROFIT } from '../../constants';
import {
  AverageDinerTimeQuery,
  ContributionMarginQuery,
  OccupationQuery
} from '../queries';

export class ProfitCalculator extends Calculator {
  kpiType = PERCENTAGE_PROFIT

  constructor(pointOfSaleGuid, currentPeriod, previousPeriod, isManaged) {
    super(pointOfSaleGuid, currentPeriod, previousPeriod, true);
  }

  async calculateKPI() {
    let props;
    if (this.previousPeriod) {
      const additionalContribution = await this.additionalContribution(this.currentPeriod);
      const prevAdditionalContribution = await this.additionalContribution(this.previousPeriod);
      let incrementContribution = this.getValueOfIncrementNoRound(additionalContribution[0], prevAdditionalContribution[0]);
      incrementContribution = incrementContribution > 0 ? incrementContribution : 0;
      const averageDinerTime = await this.averageDinerTime(this.currentPeriod);
      const prevAverageDinerTime = await this.averageDinerTime(this.previousPeriod);
      let incrementDinerTime = this.getValueOfIncrementNoRound(averageDinerTime, prevAverageDinerTime) * -1;
      incrementDinerTime = incrementDinerTime > 0 ? incrementDinerTime : 0;

      props = {
        key: `${this.pointOfSaleGuid}-${this.isManaged}`,
        kpi: additionalContribution[1],
        increment: [this.roundToDigits(incrementContribution, 1), this.roundToDigits(incrementDinerTime, 1)],
        type: this.kpiType,
      };
    } else props = this.getDataIfNoPreviousPeriod(null);
    return this.getModelToInstance(props);
  }

  async additionalContribution(period) {
    const occupation = (await this.executeUncubeQuery(OccupationQuery, period)).data.result[0][0];
    const contribution = (await this.executeUncubeQuery(ContributionMarginQuery, period)).data.result[0];
    const margin = contribution[0] - contribution[1];
    return [margin / occupation, margin];
  }

  async averageDinerTime(period) {
    const dinerTime = (await this.executeUncubeQuery(AverageDinerTimeQuery, period)).data.result[0];
    return dinerTime[0] / dinerTime[1];
  }

  getValueOfKpi(rawKpi) {
    if (!Number.isNaN(rawKpi) && Number.isFinite(rawKpi)) {
      return Math.trunc(rawKpi * 100) / 100;
    }
    return 0;
  }

  getValueOfIncrementNoRound(currentKpi, previousKpi) {
    const increment = currentKpi / previousKpi;
    return (previousKpi !== 0) ? (increment - 1) * 100 : 0;
  }

  roundToDigits(number, digits) {
    const digitConst = 10 ** digits;
    return Math.trunc(number * digitConst) / digitConst;
  }
}
